import { atom } from 'jotai'

export const managementActiveAccordionItemStateAtom = atom<number | null>(null)
export const residentActiveAccordionItemStateAtom = atom<number | null>(null)

export const selectedSocietySidebarMenuItemStateAtom = atom<string | undefined>(
  undefined
)
